import React from "react";

import { Button } from "@app/scripts/react-general-components/Button";
import { Drawer } from "@app/scripts/react-general-components/Drawer";
import { useMobile } from "@app/scripts/react-hooks/mobile";
import { useLocaleContext } from "@app/scripts/react-providers/locales";
import { AddressForm } from "@app/scripts/react-address/components/AddressForm";

import type { Address } from "@app/scripts/types";

export type Props = {
  addresses: Address[];
};

export const AddressList: React.FC<Props> = ({ addresses }) => {
  const { addresses: addressesLocale } = useLocaleContext();

  const isMobile = useMobile();

  function decodeHtmlEntities(str) {
    let tempElement = document.createElement("div");
    tempElement.innerHTML = str;
    return tempElement.textContent;
  }

  return addresses.length > 0 ? (
    <div className="account__address-list">
      {addresses?.map((address) => {
        const formAction = "/account/addresses/" + address.id;

        return (
          <div className={"account__address-item text-md " + (address.default ? "default" : "")}>
            <div className="account__address-item-title">
              <div className="account__address-item-name">
                <strong>
                  {decodeHtmlEntities(address.first_name)} {decodeHtmlEntities(address.last_name)}
                </strong>
              </div>
              {address.default && <span className="badge badge--icon">Primary Address</span>}
            </div>
            <span>{address?.address1}</span>
            <span>{address?.address2}</span>
            <span>
              {address?.city}, {address?.province_code} {address.zip}
            </span>
            <span>{address?.country}</span>
            <span className="address-list__phone">{address?.phone}</span>

            <div className="flex">
              <Drawer
                customButton={({ toggleOpen }) => (
                  <Button onClick={toggleOpen} variant="text" label={addressesLocale?.edit || "Edit"} />
                )}
                heading={addressesLocale?.edit_address || "Edit Address"}
                drawerClassName="edit-account__drawer"
                opensFrom={isMobile ? "bottom" : "right"}
              >
                <AddressForm address={address} />
              </Drawer>

              <form className="delete-account-address" method="post" action={formAction}>
                <input type="hidden" name="_method" value="delete" />
                <button type="submit" className="button button button--text">
                  <span>Delete</span>
                </button>
              </form>
            </div>
          </div>
        );
      })}

      <Drawer
        customButton={({ toggleOpen }) => (
          <Button onClick={toggleOpen} variant="small" className="edit-account__new-address" label="Add New Address" />
        )}
        heading={addressesLocale?.add || "Add new Address"}
        drawerClassName="edit-account__drawer"
        opensFrom={isMobile ? "bottom" : "right"}
      >
        <AddressForm newAddress />
      </Drawer>
    </div>
  ) : (
    <p>{addressesLocale?.empty || "No addresses set"}</p>
  );
};
